<div class="p-col-nopad">
    <div class="p-col-12 p-col-nopad">
        <div class="p-col-6 negativeCurrencyBalance">
            <mat-icon>trending_down</mat-icon>
            <span class="alert-summary-badge">3</span>
            <span class="negativeCurrencyBalanceTooltipText">Negative Currency Balance</span>
        </div>
        <div class="p-col-6">
            
        </div>
    </div>
    <div class="p-col-12 p-col-nopad">
        <div class="p-col-6 creditLineOverutilization">
            <mat-icon>credit_card</mat-icon>
        </div>
        <div class="p-col-6">
        </div>
    </div>
    <div class="p-col-12 p-col-nopad">
        <div class="p-col-6 transactionAtCutoffTime">
            <mat-icon>hourglass_empty</mat-icon>
        </div>
        <div class="p-col-6">
        </div>
    </div>
    <div class="p-col-12 p-col-nopad">
        <div class="p-col-6 todBreach">
            <mat-icon>money_off</mat-icon>
        </div>
        <div class="p-col-6">
        </div>
    </div>
    <div class="p-col-12 p-col-nopad">
        <div class="p-col-6 failedAssumption">
            <mat-icon>track_changes</mat-icon>
        </div>
        <div class="p-col-6">
        </div>
    </div>
</div>